import { FEATURE_APP_ID } from '@client-hub/shared/constants/feature-hub'
import MfeLoader from '@client-hub/shared/react/components/MfeLoader'

const Settings = () => <MfeLoader port={process.env.NX_SETTINGS_MFE_PORT!} mfeId={FEATURE_APP_ID.SETTINGS_MFE} />

export default Settings
